<modal-title
  class="modal-title-v2"
  [title]="'Settings.Team.sendInvitation' | translate"
  [closeCallback]="cancel.bind(this)"
></modal-title>
<!-- #region Content -->

<form [formGroup]="form">
  <mat-dialog-content class="pr-1">
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="mb-3">
          <div class="new-select-label">{{ 'Settings.Team.employeeEmail' | translate }}</div>
          <ng-select
            #emailSelect="ngSelectExtensionDir"
            ngSelectExtension
            class="new-select w-100 invite-email-select"
            [url]="contactsUrl"
            [responseTransform]="successOnLoadContacts.bind(this)"
            [ignoreLocalSearch]="true"
            [multiple]="false"
            bindValue="email"
            bindLabel="fullName"
            [placeholder]="'Settings.Team.employeeEmail' | translate"
            [notFoundText]="'Global.notFoundResults' | translate"
            [clearable]="false"
            [addTag]="validateEmail.bind(this)"
            searchGetParam="query"
            [addTagText]="'add' | translate"
            appendTo="body"
            (open)="syncEmailDropdownPanelWidth()"
            formControlName="email"
          />
          <span
            *ngIf="form?.get('email')?.touched && form?.get('email')?.invalid"
            class="d-flex form-control-error-msg mt-1"
            [innerHTML]="'FormErrors.required' | translate"
          ></span>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="mb-3">
          <div class="new-select-label">{{ 'Settings.Team.employeePosition' | translate }}</div>
          <ng-select
            formControlName="role"
            [items]="positionSelectOptions"
            bindLabel="name"
            bindValue="value"
            [clearable]="false"
            [placeholder]="'Settings.Team.notSelected' | translate"
            class="new-select"
            appendTo="body"
          />
        </div>
      </div>
    </div>
  </mat-dialog-content>
</form>
<mat-dialog-actions align="end">
  <div class="d-flex">
    <app-button
      class="mr-2"
      [disabled]="loading"
      (onClick)="cancel()"
      [config]="{
        type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
        text: 'Settings.Team.cancel' | translate,
        size: ButtonSize.LARGE
      }"
    ></app-button>
    <app-button
      (onClick)="submit()"
      [loading]="loading"
      [disabled]="loading"
      [config]="{
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        text: 'Settings.Team.add' | translate,
        size: ButtonSize.LARGE
      }"
    ></app-button>
  </div>
</mat-dialog-actions>
<!-- #endregion -->
